
<div class="mobile1-3">
  <div class=" centerTxt">
    
    <div class="inline txtBlkShadow">
      <p class="monthName">{{ currentMontName }} 2022</p>
    </div>
  </div>
  
  <div class=" centerTxt">
    <div class="inline">
      <button (click)="prevMonth()" mat-raised-button>Prev Month</button>
    </div>
  
    <div class="inline">
      <button (click)="nextMonth()" mat-raised-button>Next Month</button>
    </div>
  </div>
  </div>
  
  <div class="mobile4-retina">
  <div class=" centerTxt">
    
    <div class="inline">
      <button (click)="prevMonth()" mat-raised-button>Prev Month</button>
    </div>
  
    <div class="inline txtBlkShadow">
      <p class="monthName">{{ currentMontName }} 2022</p>
    </div>
  
    <div class="inline">
      <button (click)="nextMonth()" mat-raised-button>Next Month</button>
    </div>
  </div>
  </div>
  <!-- <div class="centerContainer centerTxt ">

    <div class="inline">
        <button (click)="prevMonth()" mat-raised-button>Prev Month</button>
    </div >
  
    <div class="inline">
      <p class="monthName">{{currentMontName}} 2021</p>
    </div>
    
    <div class="inline">
      <button (click)="nextMonth()" mat-raised-button>Next Month</button>
    </div>
  
  </div> -->